// extracted by mini-css-extract-plugin
export var externalLink = "_6e-0";
export var internalLinkLabel = "_6e-1";